<template>
  <div>
    <div v-if="applicationData.statusId === 1">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <p v-if="applicationData.eingangsdatum">Datum: {{applicationData.eingangsdatum | moment("DD.MM.YYYY")}}</p>

      <p>Wir prüfen, ob Ihr Gesuch vollständig ist und den Förderrichtlinien entspricht. Wir melden uns, falls Unterlagen fehlen oder nicht korrekt sind.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 2">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>

      <h4 class="red-h4 mb-1"><strong>Zusicherungsverfügung wird ausgestellt</strong></h4>
      <p>Das Gesuch ist geprüft, die Zusicherungsverfügung sollte in den nächsten Tagen ausgestellt werden.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 3 && !applicationData.eingangAusfuehrungBestaetigungDatum">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <div v-if="!applicationData.projektabschlussAuswahl">
        <strong>Nächster Schritt:</strong>
        <p><strong>Neu: Meldung Projektabschluss online einreichen!</strong></p>
        <p>Bitte geben Sie uns Ihre Bankdaten an:</p>
        <add-konto-data-modal :gesuchId="applicationData.gesuchId" :projektabschlussModal="false"/>

        <div v-if="selectedTab === 0">
          <h4 class="red-h4 mb-1"><strong>Ausführung und Abschluss (Online)</strong></h4>
          <p>Führen Sie das Projekt aus und laden Sie nach Abschluss der Arbeiten die aufgeführten Beilagen hoch:</p>
          <div class="documents-list" v-for="doc in documentsProjektabschluss" :key="doc.id">
            <div class="md-content" v-if="doc.bezeichnung === 'Beilagen Projektabschluss'">
              <vue-markdown class="md-list">{{doc.wert}}</vue-markdown>
            </div>
            <div class="md-content" v-else-if="doc.wert === null || doc.wert === ''">
              <vue-markdown class="md-list">{{doc.bezeichnung}}</vue-markdown>
            </div>
            <div class="md-content" v-else-if="(doc.wert !== null || doc.wert !== '') && doc.bezeichnung !== 'Beilagen Projektabschluss'">
              <span class="documents-title"><strong>{{doc.bezeichnung}}</strong></span>
              <vue-markdown class="md-list">{{doc.wert}}</vue-markdown>
            </div>
          </div>
        </div>
        <div v-if="selectedTab === 2">
          <h4 class="red-h4 mb-1"><strong>Auf dem Postweg</strong></h4>
          <p>Führen Sie das Projekt aus und senden Sie nach Abschluss der Arbeiten das ausgefüllte und unterzeichnete Projektabschlussformular zusammen mit den darauf aufgeführten Beilagen (per Post) an folgende Adresse:</p>
          <p>
            Energieagentur St.Gallen GmbH<br>
            Kornhausstrasse 25<br>
            9000 St.Gallen
          </p>
        </div>
      </div>
      <div v-else>
        <h4 class="red-h4 mb-1"><strong>Projektabschluss erfasst</strong></h4>
        <p><strong>Weiteres Vorgehen sobald wir den Eingang bestätigt haben:</strong><br>
          Wir prüfen, ob Ihre Unterlagen zum Projektabschluss vollständig sind und den Förderrichtlinien entsprechen.
          Wir melden uns, falls Unterlagen fehlen oder nicht korrekt sind.</p>
        <p></p>
      </div>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 3 && applicationData.eingangAusfuehrungBestaetigungDatum">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <p v-if="applicationData.eingangAusfuehrungBestaetigungDatum">Datum: {{applicationData.eingangAusfuehrungBestaetigungDatum | moment("DD.MM.YYYY")}}</p>

      <p>Wir prüfen, ob Ihre Unterlagen zum Projektabschluss vollständig sind und den Förderrichtlinien entsprechen. Wir melden uns, falls Unterlagen fehlen oder nicht korrekt sind.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 4">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>

      <h4 class="red-h4 mb-1"><strong>Nächste Schritte</strong></h4>
      <p>Der Projektabschluss wurde geprüft. Sie erhalten in Kürze weitere Infos.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 5">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <p v-if="applicationData.zusicherung">Fristablauf: {{applicationData.zusicherung.firstAblauf | moment("DD.MM.YYYY")}}</p>

      <h4 class="red-h4 mb-1"><strong>Energiemengen messen</strong></h4>
      <p>Messen Sie die Energiemengen im ersten Betriebsjahr. Senden Sie das Formular "Meldung Messung" (siehe Anhang zur Teilzahlung) zusammen mit den Messergebnissen (per Post) an folgende Adresse:</p>
      <p>
        Energieagentur St.Gallen GmbH<br>
        Kornhausstrasse 25<br>
        9000 St.Gallen
      </p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(3)" ><a class="file-download" @click="openFile(returnFileType(3))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Auszahlung <download-icon class="ml-2" :size="22"/></a></p>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 6">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>

      <h4 class="red-h4 mb-1"><strong>Auszahlungsschreiben folgt</strong></h4>
      <p>Die eingereichten Messwerte sind geprüft, das Auszahlungsschreiben sollte in den nächsten Tagen ausgestellt werden.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(3)" ><a class="file-download" @click="openFile(returnFileType(3))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Auszahlung <download-icon class="ml-2" :size="22"/></a></p>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 7">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>

      <h4 class="red-h4 mb-1"><strong>Schlusszahlung erfolgt</strong></h4>
      <p>Der Projektabschluss wurde geprüft, das Auszahlungsschreiben ist hier zum Download bereit.</p>
      <p>Hinweis: Beträge und Datum finden Sie unter Gesuchsdetails, ganz unten auf der Seite, siehe Zusatzinfos.</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <p v-if="userFilesToDownload.length && returnFileType(3)" ><a class="file-download" @click="openFile(returnFileType(3))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Auszahlung <download-icon class="ml-2" :size="22"/></a></p>
      <p v-if="userFilesToDownload.length && returnFileType(2)" ><a class="file-download" @click="openFile(returnFileType(2))" href="javascript:void(0)"><file-icon class="icon-gray" :size="18"/> Zusicherung <download-icon class="ml-2" :size="22"/></a></p>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="false"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else-if="applicationData.statusId === 12">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <h4 class="red-h4 mb-1"><strong>Checkliste der notwendigen Beilagen</strong></h4>
      <div class="documents-list" v-for="doc in documents" :key="doc.id">
        <div class="md-content" v-if="doc.bezeichnung === 'Notwendige Beilagen:'">
          <span class="documents-title"><strong>Dokument</strong></span>
          <vue-markdown class="md-list">{{doc.wert}}</vue-markdown>
        </div>
        <div class="md-content" v-else-if="doc.wert === null || doc.wert === ''">
          <vue-markdown class="md-list">{{doc.bezeichnung}}</vue-markdown>
        </div>
        <div class="md-content" v-else-if="(doc.wert !== null || doc.wert !== '') && doc.bezeichnung !== 'Notwendige Beilagen:'">
          <span class="documents-title"><strong>{{doc.bezeichnung}}</strong></span>
          <vue-markdown class="md-list">{{doc.wert}}</vue-markdown>
        </div>
      </div>
      <p><a class="file-download" href="/Documents/Static/Vollmacht/Vorlage_Vollmacht.pdf" target="_blank"><file-icon class="icon-gray" :size="18"/> Vorlage_Vollmacht.pdf <download-icon class="ml-2" :size="22"/></a></p>
    </div>

    <div v-else-if="applicationData.statusId === 13">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <h4 class="red-h4 mb-1"><strong>Gesuch abgebrochen</strong></h4>
    </div>

    <div v-else-if="applicationData.statusId === 14">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <h4 class="red-h4 mb-1"><strong>Gesuch abgelehnt</strong></h4>
      <p>Hinweis: Die Begründung finden Sie auf der Ablehnungsverfügung, welche Sie per Post erhalten.</p>
    </div>

    <div v-else-if="applicationData.statusId === 16">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <h4 class="red-h4 mb-1"><strong>Weitergeleitet an</strong></h4>
      <permission-signature-list :applicationId="applicationData.gesuchId"/>
      <h4 class="red-h4 my-3"><strong>Vorlagen</strong></h4>
      <p><a class="file-download" href="/Documents/Static/Vollmacht/Vorlage_Vollmacht.pdf" target="_blank"><file-icon class="icon-gray" :size="18"/> Vorlage_Vollmacht.pdf <download-icon class="ml-2" :size="22"/></a></p>
    </div>

    <div v-else-if="applicationData.statusId === 17">
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: {{applicationData.status}}</b-badge></h4>
      <h4 class="red-h4 mb-1"><strong>Gesuch signiert und abgeschickt</strong></h4>
      <p>Vielen Dank! Sie haben das Gesuch erfolgreich signiert und abgeschickt. Wir werden Ihr Gesuch intern bestätigen und bearbeiten.<br>Energieagentur St.Gallen GmbH</p>
      <h4 class="red-h4 my-3"><strong>Download</strong></h4>
      <sign-button-download
        :applicationId="Number(this.applicationData.gesuchId)"
        :showSpinner="true"
        buttonArt="digitaldetail"
        :gesuchArt="this.applicationData.gesuchArt"
      />
    </div>

    <div v-else>
      <h4><b-badge class="gesuchsstatus-badge primary" pill><information-outline :size="18"/> Status: Nicht verfügbar</b-badge></h4>
    </div>

  </div>
</template>

<script>
  import InformationOutline from 'vue-material-design-icons/InformationOutline.vue'
  import { errorHandler } from '@/helpers/formHelper.js'
  import { mapGetters } from 'vuex'
  import FileIcon from 'vue-material-design-icons/FileOutline.vue'
  import DownloadIcon from 'vue-material-design-icons/TrayArrowDown.vue'
  import VueMarkdown from 'vue-markdown'
  import PermissionSignatureList from '@/components/application/DigitalApplication/Permission/PermissionSignatureList.vue'
  import SignButtonDownload from '@/components/files/SignButton.vue'
  import AddKontoDataModal from '@/components/application/DigitalApplication/Modals/AddKontoDataModal.vue'

  export default {
    data: () => ({
      documentsDownloaded: false
    }),
    props: {
      applicationData: {
        type: Object,
        required: true
      },
      selectedTab: {
        type: Number
      }
    },
    components: {
      InformationOutline,
      FileIcon,
      DownloadIcon,
      VueMarkdown,
      PermissionSignatureList,
      SignButtonDownload,
      AddKontoDataModal
    },
    methods: {
      async getDocumentsByGesuchsArtId () {
        this.$store.dispatch('codes/GET_DOCUMENTS_BY_GESUCHSART', this.applicationData.gesuchsartId).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      async getDocumentsByGesuchsArtIdProjektabschluss () {
        this.$store.dispatch('codes/GET_DOCUMENTS_BY_GESUCHSART_PROJEKTABSCHLUSS', this.applicationData.gesuchsartId).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      async getUserFilesToDownload () {
        this.$store.dispatch('cloudinary/GET_USER_FILES_TO_DOWNLOAD', this.applicationData.gesuchId).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      async openFile (item) {
        const base64 = 'data:application/pdf;base64,' + item.fileContentBase64
        const blob = await (await fetch(base64)).blob()
        const objectURL = URL.createObjectURL(blob)

        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = objectURL
        a.download = item.fileName
        a.click()
        URL.revokeObjectURL(objectURL)
      },
      returnFileType (fileType) {
        const returnedElements = this.userFilesToDownload.find(el => el.fileType === fileType)
        return returnedElements
      }
    },
    watch: {
      applicationData: function (newVal, oldVal) {
        this.getDocumentsByGesuchsArtId()
        if (this.applicationData.statusId === 3) {
          this.getDocumentsByGesuchsArtIdProjektabschluss()
        }
        if ([3, 4, 5, 6, 7].includes(this.applicationData.statusId)) {
          this.getUserFilesToDownload()
        }
      }
    },
    computed: {
      ...mapGetters({
        documents: 'codes/DOCUMENTS',
        documentsProjektabschluss: 'codes/DOCUMENTS_PROJEKTABSCHLUSS',
        userFilesToDownload: 'cloudinary/CLIENT_DOWNLOAD_FILES'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .status-title{
    color: $magenta;
    margin-bottom: 12px;
    overflow: hidden;
    line-height: 24px;
    position: relative;

    .status-circle{
      padding-left: 30px;
    }

    .status-circle:before{
      content:'';
      position: absolute;
      width: 24px;
      height: 24px;
      background: $green;
      border-radius: 50%;
      border: 2px solid $gray;
      left: 0;
    }

    .icon {
      line-height: 1 !important;
      margin-right: 5px;
      display: inline-block;
      font-size: 1.5rem;
      vertical-align: middle;
    }
  }
  h4{
    color: $magenta;
  }

  .gesuchsstatus-badge {
    padding: 0.5rem 1rem;
    font-size: $h6-font-size;

    &.primary {
      background-color: $magenta;
      color: $white;
      font-weight: $font-weight-light;
    }
  }

  .icon-gray {
    background-color: $black-10;
    padding: 3px .5rem .5rem;
    border-radius: 0.5rem;
    margin-right: 0.25rem;
  }

  .file-download {
    text-decoration: none;
  }
</style>
